import { render } from "./Dokumentasi.vue?vue&type=template&id=1664b288"
import script from "./Dokumentasi.vue?vue&type=script&lang=js"
export * from "./Dokumentasi.vue?vue&type=script&lang=js"

import "./Dokumentasi.vue?vue&type=style&index=0&id=1664b288&lang=css"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__